import { render, staticRenderFns } from "./UploadDDA.vue?vue&type=template&id=29f4d984&"
import script from "./UploadDDA.vue?vue&type=script&lang=js&"
export * from "./UploadDDA.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports